<template>
    <div>
        {{ showopenmodalcomp }}
        <div v-if="showopenmodal">
            <!-- template for the modal component -->
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-md" style="display: block !important">
                            <div class="modal-content">
                                <!-- Modal Header -->
                                <div class="modal-header pb-0">
                                    <h5 class="modal-title text-center pull-left w-100 d-block mt-4 pb-0">
                                        Print Header Settings
                                    </h5>
                                    <button type="button" class="close" data-dismiss="modal" @click="cancelAction()">
                                        <i class="material-icons">close</i>
                                    </button>
                                </div>
                                <!-- Modal body -->
                                <div class="modal-body p-0">
                                    <div>
                                        <div v-if="showspinner" class="appointmentlist-spinner">
                                            <div class="processing_popup full-spinner" style="
                            visibility: visible;
                            top: -68px;
                            height: 261px;
                            z-index: 9999999999;
                          ">
                                                <div class="spinner cover-spin">
                                                    <div class="bounce1"></div>
                                                    <div class="bounce2"></div>
                                                    <div class="bounce3"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="pl-3 pr-3 pb-5">
                                            <label class="radio-container" style="width: 40% !important">
                                                Clinic
                                                <input name="drugdatabase" type="radio" value="provider"
                                                    v-model="selectedHS" /><span
                                                    class="radio-checkmark"></span></label><label
                                                class="radio-container" style="width: 50% !important">
                                                Hospital
                                                <input name="drugdatabase" type="radio" value="hospital"
                                                    v-model="selectedHS" /><span class="radio-checkmark"></span></label>
                                        </div>
                                        <div v-if="ishospital" class="col-md-12">
                                            <!-- v-bind:class="{ 'disable-hold': relationshipIsself, 'error-msg-hold': userpname && !patientname }" -->
                                            <div class="form-group" v-bind:class="{ 'error-msg-hold':  emailError }">
                                                <div class="container-comm">
                                                    <input v-model="hospitalemaildata" type="text" autocomplete="off"
                                                        name="uname" title required @input="validateEmail">
                                                    <label for="pname">
                                                        <b>{{ $t('HospitalEmail') }} </b>
                                                    </label>
                                                     <small v-if="emailError" class="text-danger">{{ emailError }}</small>
                                                </div>
                                            </div>
                                            <div class="form-group" v-bind:class="{ 'error-msg-hold': contactError }">
                                                <div class="container-comm">
                                                    <input v-model="hospitalcontactdata" type="text" maxlength="40"
                                                        @input="validateContact" required/>
                                                    <label><b>Contact No</b></label>
                                                    <small v-if="contactError" class="text-danger">{{ contactError }}</small>
                                                </div>
                                            </div>
                                            <div class="form-group" v-bind:class="{ 'error-msg-hold':  websiteError  }">
                                                <div class="container-comm">
                                                    <input v-model="hospitalwebsitedata" type="text" autocomplete="off"
                                                        name="uname" title required @input="validateWebsite">
                                                    <label for="pname">
                                                        <b>{{ $t('HospitalWebsite') }} </b>
                                                    </label>
                                                     <small v-if="websiteError" class="text-danger">{{ websiteError }}</small>
                                                </div>
                                            </div>
                                           <div class="form-group" v-bind:class="{ 'error-msg-hold': gstError }">
                                                <div class="container-comm">
                                                    <input v-model="hospitalgstnodata" type="text" maxlength="15"
                                                        @input="onlyAlphanumeric" required/>
                                                    <label><b>{{ $t('HospitalGSTNo') }}</b></label>
                                                    <small v-if="gstError" class="text-danger">{{ gstError }}</small>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <!-- Time From -->
                                               <div class="form-group col-md-6" v-bind:class="{ 'error-msg-hold': timeFromError }">
                                                    <div class="select">
                                                        <select class="select-text" v-model="timeFrom" required>
                                                            <option value=""></option>
                                                            <option v-for="time in timeOptions" :key="time"
                                                                :value="time">
                                                                {{ time }}
                                                            </option>
                                                        </select>
                                                        <span class="select-highlight"></span>
                                                        <span class="select-bar"></span>
                                                        <label class="select-label">Time From</label>
                                                        <small class="text-danger">{{ timeFromError }}</small>
                                                    </div>
                                                </div>
                                                <div class="form-group col-md-6" v-bind:class="{ 'error-msg-hold': timeToError }">
                                                    <div class="select">
                                                        <select class="select-text" title required v-model="timeTo">
                                                            <option v-for="time in filteredTimeTo" :key="time"
                                                                :value="time">
                                                                {{ time }}
                                                            </option>
                                                        </select>
                                                        <span class="select-highlight"></span>
                                                        <span class="select-bar"></span>
                                                        <label class="select-label">Time To</label>
                                                        <small class="text-danger">{{ timeToError }}</small>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-row bg-light p-3 rounded mt-2">
                                                <div class="col text-center" v-for="day in weekdays" :key="day.value">
                                                    <div class="custom-control custom-switch d-inline-block">
                                                        <input type="checkbox" class="custom-control-input"
                                                            :id="day.value" :value="day.value" v-model="selectedDays">
                                                        <label class="custom-control-label" :for="day.value"></label>
                                                    </div>
                                                    <div class="small mt-1">{{ day.label }}</div>
                                                </div>
                                                <div class="text-danger small">{{ daysError }}</div>
                                            </div>
                                        </div>

                                        <div class="pull-left mb-4 pl-5 pr-5 col-md-12 mt-2">
                                            <slot name="footer">
                                                <button type="button" class="secondary-btn ripple pull-left"
                                                    @click="resetsetting()">
                                                    Reset
                                                </button>
                                                <button type="button" class="primary-btn ripple pull-right"
                                                    @click="saveSettings()">
                                                    Save
                                                </button>
                                            </slot>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <!-- <transition name="fade"> -->
        <Messages v-if="isdisplaymsg" v-bind:datamessage="sucessmsgtext" v-bind:iserror="iserrormsg"
            v-on:closemsg="closeMessage" v-bind:isVisible="isdisplaymsg"></Messages>
        <!-- </transition> -->
    </div>
</template>


<script>
import rest_service from "@/api/rest_service";
import Axios from "axios";
import Messages from "@/components/MessagePopup/Messages";
import SubscriptionApi from "../../api/subscription.js";
import { mapActions, mapGetters, Store } from "vuex";

const suburl = "/business-setup";
export default {
    name: "Header_print_setting",
    props: ["showmodal", "parentprop", "drugdboption"],
    components: { Messages },
    data() {
        return {
            //For Messages popup
            isdisplaymsg: false,
            sucessmsgtext: "",
            iserrormsg: false,
            showopenmodal: false,
            selectedHS: "provider",
            loggedInUser: null,
            showspinner: false,
            prevSelected: "provider",
            hospitalemaildata: "",
            hospitalwebsitedata: "",
            hospitalcontactdata:"",
            hospitalgstnodata: "",
            emailError: "",
            contactError:"",
            websiteError: "",
            gstError:"",
            timeFrom: "",
            timeTo: "",
            timeFromError: "",
            timeToError: "",
            daysError: "",
            selectedDays: [],

            weekdays: [
                { label: "Monday", value: "Monday" },
                { label: "Tuesday", value: "Tuesday" },
                { label: "Wednesday", value: "Wednesday" },
                { label: "Thursday", value: "Thursday" },
                { label: "Friday", value: "Friday" },
                { label: "Saturday", value: "Saturday" },
                { label: "Sunday", value: "Sunday" }
            ],

            timeOptions: []
        };  
    },
    methods: {
        generateTimes() {

            var times = [];
            var start = new Date();
            start.setHours(0, 0, 0, 0);   // 12:00 AM

            for (var i = 0; i < 48; i++) {

                var hours = start.getHours();
                var minutes = start.getMinutes();

                var ampm = hours >= 12 ? "PM" : "AM";
                var hour12 = hours % 12;
                hour12 = hour12 ? hour12 : 12;

                var formatted =
                    (hour12 < 10 ? "0" + hour12 : hour12) +
                    ":" +
                    (minutes < 10 ? "0" + minutes : minutes) +
                    " " +
                    ampm;

                times.push(formatted);

                start.setMinutes(start.getMinutes() + 30);
            }

            this.timeOptions = times;
        },
        cancelAction() {
            this.selectedHS = "1";
            this.showopenmodal = false;
            this.parentprop.opencloseheadersettmodal = false;
        },
        validateEmail() {
            const emailPattern =
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;

            if (this.hospitalemaildata && !emailPattern.test(this.hospitalemaildata)) {
                this.emailError = "Enter a valid email address";
            } else {
                this.emailError = "";
            }
        },

        validateWebsite() {
            const websitePattern =
                /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/.*)?$/;

            if (this.hospitalwebsitedata && !websitePattern.test(this.hospitalwebsitedata)) {
                this.websiteError = "Enter a valid website URL";
            } else {
                this.websiteError = "";
            }
        },
        validateContact() {
            // strip anything that isn't a digit, +, space, or comma
            this.hospitalcontactdata = this.hospitalcontactdata.replace(/[^0-9+ ,]/g, "");

            if (this.hospitalcontactdata && !/^[0-9+ ,]+$/.test(this.hospitalcontactdata)) {
                this.contactError = "Only numbers, +, space and comma are allowed";
            } else {
                this.contactError = "";
            }
        },
        onlyAlphanumeric() {
            this.hospitalgstnodata = this.hospitalgstnodata
                .toUpperCase()
                .replace(/[^A-Z0-9]/g, "");
        },
        getBusinessSetup() {
            var tenantbusinesssetup = JSON.parse(window.localStorage.getItem("tenantbusinesssetup"));
            if (tenantbusinesssetup != null) {
                this.selectedHS = tenantbusinesssetup.printheadersetting;
                if (tenantbusinesssetup.printheadersetting === "hospital") {
                    const hospitaldata = tenantbusinesssetup.hospitalHeaderObject;
                    if (hospitaldata) {
                        if (hospitaldata.hospitalgstno) {
                            this.hospitalgstnodata = hospitaldata.hospitalgstno;
                        }

                        if (hospitaldata.hospitalwebsite) {
                            this.hospitalwebsitedata = hospitaldata.hospitalwebsite;
                        }

                        if (hospitaldata.hospitalemail) {
                            this.hospitalemaildata = hospitaldata.hospitalemail;
                        }

                        if (hospitaldata.hospitalcontact) {
                            this.hospitalcontactdata = hospitaldata.hospitalcontact;
                        }

                        if (hospitaldata.hospitaltimings) {
                            if (hospitaldata.hospitaltimings.time_from) {
                                this.timeFrom = hospitaldata.hospitaltimings.time_from;
                            }
                            if (hospitaldata.hospitaltimings.time_to) {
                                this.timeTo = hospitaldata.hospitaltimings.time_to;
                            }
                            if (hospitaldata.hospitaltimings.days) {
                                this.selectedDays = hospitaldata.hospitaltimings.days;
                            }
                        }
                    }
                }
            }
            else {

                SubscriptionApi.getbusinesssetup()
                    .then((response) => {
                        if (response.data && response.data.result) {
                            localStorage.setItem("tenantbusinesssetup", JSON.stringify(response.data.result));
                            var tenantbusinesssetup = JSON.parse(window.localStorage.getItem("tenantbusinesssetup"));
                            if (tenantbusinesssetup && tenantbusinesssetup.printheadersetting === "hospital") {
                                const hospitaldata = tenantbusinesssetup.hospitalHeaderObject;
                                if (hospitaldata) {
                                    if (hospitaldata.hospitalgstno) {
                                        this.hospitalgstnodata = hospitaldata.hospitalgstno;
                                    }

                                    if (hospitaldata.hospitalwebsite) {
                                        this.hospitalwebsitedata = hospitaldata.hospitalwebsite;
                                    }

                                    if (hospitaldata.hospitalemail) {
                                        this.hospitalemaildata = hospitaldata.hospitalemail;
                                    }

                                    if (hospitaldata.hospitalcontact) {
                                        this.hospitalcontactdata = hospitaldata.hospitalcontact;
                                    }

                                    if (hospitaldata.hospitaltimings) {
                                        if (hospitaldata.hospitaltimings.time_from) {
                                            this.timeFrom = hospitaldata.hospitaltimings.time_from;
                                        }
                                        if (hospitaldata.hospitaltimings.time_to) {
                                            this.timeTo = hospitaldata.hospitaltimings.time_to;
                                        }
                                        if (hospitaldata.hospitaltimings.days) {
                                            this.selectedDays = hospitaldata.hospitaltimings.days;
                                        }
                                    }
                                }
                            }
                            this.selectedHS = tenantbusinesssetup.printheadersetting;
                        }
                    })
                    .catch((error) => console.log(error));
            }
        },
        validation() {

            this.emailError = "";
            this.contactError="";
            this.websiteError = "";
            this.gstError = "";
            this.timeFromError = "";
            this.timeToError = "";
            this.daysError = "";

            if (this.selectedHS === "provider") {
                return false;
            }

            let hasError = false;

            const emailPattern =
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;

            if (this.hospitalemaildata && !emailPattern.test(this.hospitalemaildata)) {
                this.emailError = "Enter valid email";
                hasError = true;
            }
            if (this.hospitalcontactdata && !/^[0-9+ ,]+$/.test(this.hospitalcontactdata)) {
                this.contactError = "Only numbers, +, space and comma are allowed";
                hasError = true;
            }
            const websitePattern =
                /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/.*)?$/;

            if (this.hospitalwebsitedata && !websitePattern.test(this.hospitalwebsitedata)) {
                this.websiteError = "Enter valid website URL";
                hasError = true;
            }

            if (this.hospitalgstnodata && this.hospitalgstnodata.length !== 15) {
                this.gstError = "Enter valid GST number";
                hasError = true;
            }

            // ---- Timing Validation ----

            if (!this.timeFrom) {
                this.timeFromError = "Select start time";
                hasError = true;
            }

            if (!this.timeTo) {
                this.timeToError = "Select end time";
                hasError = true;
            }

            if (this.selectedDays.length === 0) {
                this.daysError = "Select at least one day";
                hasError = true;
            }
            if (this.timeFrom && this.timeTo && this.timeFrom === this.timeTo) {
                this.timeToError = "End time must be after start time";
                hasError = true;
            }
            return hasError;
        },
        saveSettings() {
            var self = this;
            self.showspinner = true;
            //self.parentprop.opencloseheadersettmodal = false;
            if(self.validation()){
                self.showspinner = false;
                return;
            }
            debugger
            let hospitaltimings = self.ishospital ? {
                time_from: self.timeFrom,
                time_to: self.timeTo,
                days: self.selectedDays
            } : {};
            Axios.request({
                method: "put",
                url: rest_service.baseURL + "/staff/updateheadersettings",
                headers: {
                    x_tenant_id: localStorage.tenantid,
                    role_unique_id: this.loggedInUser.role.unique_id,
                    route_entity_name: "/updateheadersettings",
                    loggedin_user_unique_id: this.loggedInUser.unique_id,
                    Authorization: localStorage.accesstoken,
                },
                withCredentials: false,
                data: {
                    hospitalgstno: self.ishospital ? self.hospitalgstnodata : "",
                    hospitalwebsite: self.ishospital ? self.hospitalwebsitedata : "",
                    hospitalemail: self.ishospital ? self.hospitalemaildata : "",
                    hospitalcontact :self.hospitalcontactdata ? self.hospitalcontactdata :"",
                    displaysetting: self.selectedHS,
                    hospitaltimings:hospitaltimings
                }
            })
                .then((respo) => {
                    debugger
                    if (
                        respo.data &&
                        respo.data.result &&
                        respo.status) {
                        window.localStorage.removeItem("tenantbusinesssetup");    
                        self.showspinner = false;
                        localStorage.setItem("tenantbusinesssetup", JSON.stringify(respo.data.result));
                        self.parentprop.opencloseheadersettmodal = false;    
                        self.isdisplaymsg = true;
                        self.iserrormsg = false;
                        self.sucessmsgtext =
                            "Print Header Display Settings " +
                            self.$store.state.helper.alertmessage.saved;
                        setTimeout(
                            function () {
                                self.closeMessage();
                            }.bind(self),
                            3000
                        );
                    } else {
                        self.showspinner = false;
                        self.parentprop.opencloseheadersettmodal = false;
                        self.isdisplaymsg = true;
                        self.iserrormsg = true;
                        self.sucessmsgtext =
                            respo.data.result
                        setTimeout(
                            function () {
                                self.closeMessage();
                            }.bind(self),
                            3000
                        );

                    }
                })
                .catch((ex) => {
                    self.showspinner = false;
                    self.parentprop.opencloseheadersettmodal = false;
                    self.isdisplaymsg = true;
                    self.iserrormsg = true;
                    self.sucessmsgtext =
                        "Prescription Display Settings " +
                        self.$store.state.helper.alertmessage.failupdate;
                    setTimeout(
                        function () {
                            self.closeMessage();
                        }.bind(self),
                        3000
                    );
                })

        },
        resetsetting(){
            var self=this;
            self.selectedHS=self.prevSelected;
            self.hospitalgstnodata=null;
            self.gstError=null;
            self.hospitalemaildata=null;
            self.hospitalwebsitedata=null;
            self.hospitalcontactdata=null;
            self.timeFrom=null;
            self.timeTo=null;
            self.selectedDays=[];
        },
        closeMessage() {
            this.isdisplaymsg = false;
        },

    },
    created() {
        this.generateTimes();
        this.loggedInUser = JSON.parse(localStorage.loggedInUserInfo);
    },
    computed: {
        showopenmodalcomp() {
            var self = this;
            self.showopenmodal = self.showmodal;
            if (self.showopenmodal) {
                self.showspinner = false;
                self.getBusinessSetup();
            }
        },
        ishospital() {
            return this.selectedHS === "hospital";
        },
        filteredTimeTo() {

            if (!this.timeFrom) return this.timeOptions;

            var index = this.timeOptions.indexOf(this.timeFrom);

            var options = this.timeOptions.slice(index + 1);

            // special case for 11:30 PM
            if (this.timeFrom === "11:30 PM") {
                options = ["11:59 PM"];
            }

            return options;

        }
    },
    watch: {
        hospitalgstnodata(){
            var self=this;
            if(self.hospitalgstnodata ==null || self.hospitalgstnodata.length>=15 ){
                self.gstError='';
            }
            else
            self.gstError='Enter valid GST number';
        },
         timeFrom(newVal) {
             if (this.timeFromError) {
                 this.timeFromError = "";
             }
            var index = this.timeOptions.indexOf(newVal);

            if (index === this.timeOptions.length - 1) {
                this.timeTo = "11:59 PM";
            } else {
                this.timeTo = this.timeOptions[index + 1];
            }

        },

        timeTo() {
            if (this.timeToError) {
                this.timeToError = "";
            }
        },

        selectedDays() {
            if (this.daysError) {
                this.daysError = "";
            }
        }
    },
};
</script>

<style scoped>
.radio-container {
    width: auto !important;
    margin-left: 15px;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 300px;
    margin: 0px auto;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
}

.modal-header h3 {
    margin-top: 0;
    color: #42b983;
}

.modal-body {
    margin: 20px 0;
}

.modal-default-button {
    float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.modal-container.modal-width500 {
    max-width: 650px;
    width: 100%;
}

.modal-container.modal-width500 .modal-header {
    border-bottom: 1px solid transparent !important;
    padding-bottom: 0px !important;
}

.modal-container.modal-width500 .modal-footer {
    border-top: 1px solid transparent !important;
}

.modal-container.modal-width500 .modal-header {
    min-height: 10px !important;
}

.modal-container.modal-width500 .modal-body {
    margin: 0px !important;
}

.select .sector-select {
    color: #000 !important;
}

.category-select-default.single .select-txt {
    position: relative;
    z-index: 999999999;
    top: -45px;
    display: block;
    color: #000 !important;
    width: 90%;
    height: 19px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.category-select-default.single .select-txt {
    color: #777;
}

input[type="checkbox"],
input[type="radio"] {
    height: 19px !important;
    width: 100%;
    left: 0px;
    z-index: 1;
}
</style>